import React from 'react';
import { useTranslation } from 'react-i18next';
import './TranscoderModeInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { TranscoderModeEnum } from '../../../types/enums/TranscoderModeEnum';
import useProject from '../../../hooks/useProject';

const TranscoderModeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in TranscoderModeEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${TranscoderModeEnum[key as keyof typeof TranscoderModeEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          transcoderMode: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderMode: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="transcoder-mode-input">
      <div className="input-title">{t('producer.inputs.transcoder-mode.title')}</div>
      <Dropdown
        value={project.encoder.transcoderMode.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.transcoder-mode.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.transcoder-mode.footer')}</div>
    </div>
  );
};

export default React.memo(TranscoderModeInput);
